export const AdsOptOutCookie = "3PAdsOptOut";
export const MsccCookie = "MSCC";
export const MuidCookie = "MUID";

const defaultExpiryDateInDaysFromToday = 45;

const getExpiryDate = (daysFromToday?: number): Date => {
  const date = new Date();
  date.setDate(date.getDate() + (daysFromToday ? daysFromToday : defaultExpiryDateInDaysFromToday));
  return date;
};

type CookieOptions = {
  name: string;
  value: string;
  expires?: Date;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: "lax" | "strict" | "none";
  sessionCookie?: boolean;
};

export function setCookie({
  name,
  value,
  expires,
  path,
  domain,
  secure,
  sameSite,
  sessionCookie,
}: CookieOptions): void {
  const cookieExpireDate =
    expires instanceof Date ? expires : getExpiryDate(defaultExpiryDateInDaysFromToday);
  const resolvedPath = path ?? "/";
  const resolvedSecure = secure ?? true;

  let cookieText = `${name}=${value}`;

  // If neither 'expires' nor 'max-age' are specified, the cookie will expire at the end of the session.
  if (sessionCookie !== true) {
    cookieText += `; expires=${cookieExpireDate.toUTCString()}`;
  }

  cookieText += `; path=${resolvedPath}`;
  if (domain) {
    cookieText += `; domain=${domain}`;
  }

  if (resolvedSecure) {
    cookieText += "; secure";
  }
  if (sameSite) {
    cookieText += `; samesite=${sameSite}`;
  }

  document.cookie = cookieText;
}

export const getClientCookie = (cookieName: string): string | undefined => {
  if (typeof window === "undefined") {
    throw new Error("getClientCookie should only be invoked on the client");
  }

  if (!document.cookie) {
    return;
  }

  return document.cookie
    .split("; ")
    .find(row => row.startsWith(`${cookieName}=`))
    ?.split("=")[1];
};

export const cookieExists = (name: string): boolean =>
  document.cookie.split("; ").some(row => row.startsWith(`${name}=`));

// To delete a cookie, set its expiration date to a past date
const deleteExpireTime = ";expires=Thu, 01 Jan 1970 00:00:00 GMT";

export function deleteCookie(name: string, path?: string, domain?: string): void {
  if (cookieExists(name)) {
    document.cookie = `${name}=${path ? `;path=${path}` : ""}${
      domain ? `;domain=${domain}` : ""
    }${deleteExpireTime}`;
  }
}
